import * as React from 'react';
import { Events, Linked } from "@type-r/models";
import { useModel } from "@type-r/react";
import { Activity } from "api/activity";
import { InvoiceModel } from "api/invoice";
import { localUserInfo } from 'api';
import { CompactTextArea, Flex, PopupIODialog } from 'lqx-react/lib';
import { makeStyles } from '@material-ui/core';


export const CommentDialog = ({ $isOpen, invoice }: { $isOpen: Linked<boolean>, invoice: InvoiceModel }) => {
    const invoiceCommentActivity = useModel(Activity);
    
    React.useEffect(() => {
        invoiceCommentActivity.$.type.set('Invoice_CommentAdded');
    }, []);

    const addComment = async () => {
        const activity = invoiceCommentActivity.clone();
        activity.assetId = invoice.id;
        activity.relationshipId = localUserInfo.getRelationshipId(invoice.conversationId);
        
        await Activity.saveActivities(Array.from([activity]), 'Invoice');
    }

    let styles = useStyles();

    return (
        <PopupIODialog
            $isOpen={$isOpen}
            title={"Add comments"}
            actionLabel={"Save"}
            success={"Comment added"}
            onSuccess={() => Events.trigger("Invoice:refresh")}
            doIO={addComment}
            disabled={!invoiceCommentActivity.comment}
        >
            <Flex className={styles.popup}>
                <CompactTextArea label="" rows={10} $value={invoiceCommentActivity.$.comment} />
            </Flex>
        </PopupIODialog>
    );
}

const useStyles = makeStyles({
    popup: {
        minHeight: 200
    }
});